/**
 * Returns true when the keyboard event originated from a field where the user
 * types text, so global sourcing table shortcuts should not run.
 */
export function isKeyboardEventFromEditableField(event: KeyboardEvent) {
  const target = event.target;
  let element: Element | null = null;
  if (target instanceof Element) {
    element = target;
  } else if (target instanceof Text) {
    element = target.parentElement;
  }
  if (element === null) {
    return false;
  }
  if (element instanceof HTMLElement && element.isContentEditable) {
    return true;
  }
  if (element.closest('[contenteditable="true"]')) {
    return true;
  }
  if (!(element instanceof HTMLElement)) {
    return false;
  }
  const tag = element.tagName;
  return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT';
}
